<template>
  <div class="itemRequest">
    <div class="d-flex align-items-center">
      <span class="itemRequest--position">{{ position }}</span>
      <div class=" ml-4">
        <span class="itemRequest--names">
          {{ data.nombre }} {{ data.apellido }}
        </span>
        <span>({{ data.email }})</span>
        <span class="ml-2">
          <strong>Vacante:</strong>
          {{
            data.vacante == "" ? "No tiene seleccionada" : data.vacante
          }}</span
        >
        <div class="mt-1">
          <span class=" m-0" style="font-size:0.9rem; color:#999999">
            {{ moment(data.fecha).format("DD/MM/yyyy") }}</span
          >
          <b-badge variant="warning" class="ml-2 mr-4 p-2">{{
            data.estatus
          }}</b-badge>
        </div>
      </div>
    </div>

    <div>
      <b-button
        v-if="data.estatus != 'Revisado'"
        class="mr-1"
        variant="primary"
        size="sm"
        @click="checkApplication(data.solicitudId)"
      >
        Marcar como revisado
      </b-button>

      <b-button
        variant="danger"
        size="sm"
        @click="downloadPDF(data.solicitudId)"
      >
        Descargar PDF
      </b-button>
    </div>
  </div>
</template>
<script>
import RequestPDF from "../utils/PDF/RequestPDF";
import moment from "moment";

export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
    position: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      moment,
    };
  },
  methods: {
    downloadPDF(id) {
      this.$loading.show()
      this.$store
        .dispatch({ type: "applyEmployer/getRequest", id })
        .then((resp) => {
       
          var Request = new RequestPDF();
          Request.generatePDF(resp.response);
           this.$loading.hide()
          this.$swal.fire(
            "Éxito",
            "Se descargo el PDF correctamente",
            "success"
          );
        })
        .catch((e) => {
          this.$loading.hide()
          this.$swal.fire("Error", "Error descargando el PDF", "error");
        });
    },
    async checkApplication(id) {
      this.$store
        .dispatch({
          type: "applyEmployer/checkApplication",
          data: { id },
        })
        .then(async (resp) => {
          this.$swal.fire("Éxito", `${resp.message}`, "success");
          await this.$store.dispatch({
            type: "applyEmployer/getListRequests",
            data: this.$store.state.applyEmployer.request,
          });
        })
        .catch((e) => {
          this.$swal.fire("Error", `${e.message}`, "error");
        });
    },
  },
};
</script>
<style scoped>
.itemRequest {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  margin: 15px 0px;
  -webkit-box-shadow: 0px 0px 6px -1px rgba(161, 155, 161, 1);
  -moz-box-shadow: 0px 0px 6px -1px rgba(161, 155, 161, 1);
  box-shadow: 0px 0px 6px -1px rgba(161, 155, 161, 1);
  border-radius: 7px;
  background: #eceff1;
}

.itemRequest--position {
  color: rgb(200, 200, 200);
}
.itemRequest--names {
  font-size: 1.1rem;
  color: #28a745;
}
</style>
